import {
  Component, Input, Output, EventEmitter, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

import { ActiveFilterModel } from 'shared/search/active-filters/active-filter.model';

import { PermissionsService } from 'shared/permissions/permissions.service';
import { SearchInputComponent } from 'shared/search/search-input/search-input.component';


@Component({
  moduleId: module.id,
  selector: 'search-page-simple-header',
  templateUrl: 'search-page-simple-header.component.html',
  styleUrls: ['search-page-simple-header.component.scss'],
})
export class SearchPageSimpleHeaderComponent {
  @Input() headerColor: string = 'darkred';
  @Input() hasAdvancedSearch: boolean = false;
  @Input() searchValue: string;
  @Input() ghostValue: string;
  @Input() actions: any = [];
  @Input() pagesMenuData: any;
  @Input() currentPageData: any;
  @Input() searchModel: any;
  @Input() searchService: any;
  @Input() searchInputPlaceholder: string;
  @Input() showSearch: boolean = true;
  @Input() filters: Array<ActiveFilterModel> = [];

  // statuses
  @Input() showStatuses: boolean = true;
  @Input() statuses: any;
  @Input() statusModel: any;
  @Input() allStatusesTitle: string;
  @Input() showStatusesDropdown: boolean = true;

  // pagination
  @Input() showPagination: boolean = true;
  @Input() totalRecords: any;
  @Input() currentPage: any;
  @Input() itemsPerPage: any;

  // tabs
  @Input() isTabsClickableWhenActive: boolean = false;
  @Input() leftTabTitle: string;
  @Input() rightTabTitle: string;
  @Input() isLeftTabActive: boolean = false;
  @Input() isRightTabActive: boolean = false;
  @Input() leftAllowClick: boolean = true;
  @Input() rightAllowClick: boolean = true;
  @Input() showTabs: boolean = true;
  @Input() pageTitle: string;

  // list manager
  @Input() showListManagerBtn: boolean = false;
  @Input() isListManagerShown: boolean = false;

  @Output() clearSearchClick: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchRun: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearchCancel: EventEmitter<any> = new EventEmitter();

  @Output() statusSelected: EventEmitter<any> = new EventEmitter();

  @Output() pageActionSelect: EventEmitter<any> = new EventEmitter();
  @Output() pageChange: EventEmitter<any> = new EventEmitter();
  @Output() itemsPerPageChange: EventEmitter<any> = new EventEmitter();
  @Output() scorecardChanged: EventEmitter<any> = new EventEmitter();
  @Output() leftTabClick: EventEmitter<any> = new EventEmitter();
  @Output() rightTabClick: EventEmitter<any> = new EventEmitter();
  @Output() listManagerBtnClick: EventEmitter<any> = new EventEmitter();

  @ViewChild(SearchInputComponent, {static: false})
  searchInput: SearchInputComponent | void;

  constructor(
    protected permissionsService: PermissionsService,
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get searchInputValue(): string {
    return _.get(this.searchInput, 'searchTermValue');
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

   public resetSearchValue(value: string) {
     if (this.searchInput) {
       this.searchInput.resetValue(value);
     }
   }

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

  onClearSearchClick() {
    this.clearSearchClick.emit();
  }

  onPageActionSelect(event: any) {
    this.pageActionSelect.emit(event);
  }

  onStatusSelected(event: any) {
    this.statusSelected.emit(event);
  }

  onLeftTabClick() {
    this.leftTabClick.emit();
  }

  onRightTabClick() {
    this.rightTabClick.emit();
  }

  onActionSelect(event: any) {
    this.pageActionSelect.emit(event);
  }

  onAdvancedSearchRun() {
    this.advancedSearchRun.emit();
  }

  onAdvancedSearchCancel() {
    this.advancedSearchCancel.emit();
  }

  onPageChange(event: any) {
    this.pageChange.emit(event);
  }

  onItemsPerPageChange(event: any) {
    this.itemsPerPageChange.emit(event);
  }
}
